<template>
  <div
    v-if="items && items.length > 0"
    class="hr"
  >
    <router-link
      to="/"
      class="home-breadcrumb text-dark"
    >
      {{ $t('page.home') }}
    </router-link>
    <template v-for="(item, i) in items">
      &nbsp;&gt;
      <router-link
        :id="`breadcrumb_${i}`"
        :key="`breadcrumb_${i}`"
        class="other-breadcrumb text-dark"
        :to="getLink(item.url)"
      >
        {{ item.name }}
      </router-link>
    </template>
  </div>
</template>
<script>
export default {
  name: "Breadcrumb",
  props: ["items"],
  methods: {
    getLink(link) {
      if (!link.startsWith("/")) {
        link = "/" + link;
      }
      return link;
    }
  }
};
</script>